import styles from './Nav.module.css';
import { site } from '../content/site.js';

export default function Nav({ theme, onToggleTheme }) {
  return (
    <nav className={styles.nav} aria-label="Primary">
      <div>W.L. / UI-DEV · AU</div>
      <div className={styles.navLinks}>
        {site.nav.map((n) => (
          <a key={n.id} href={`#${n.id}`}>
            {n.label}
          </a>
        ))}
      </div>
      <div className={styles.right}>
        <button
          className={styles.btn}
          onClick={onToggleTheme}
          aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        >
          <span className={styles.dot} aria-hidden="true" />
          <span>{theme === 'light' ? 'Dark' : 'Light'}</span>
        </button>
      </div>
    </nav>
  );
}
